import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const SellerGridSkeleton = () => {
  return (
    <div className="main-content-container seller-grid-page">
      {/* Titolo centrato */}
      <div className="skeleton-seller-grid-title skeleton-loader"></div>

      {/* Sezione Negozi Recenti - Slider */}
      <div className="seller-grid-section">
        <div className="seller-grid-section-header">
          <div className="skeleton-seller-section-title skeleton-loader"></div>
        </div>
        <div className="store-slider-wrapper">
          <div className="skeleton-seller-slider">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="store-card-custom">
                <div className="store-card-inner-custom">
                  <div className="store-logo-container-custom">
                    <div className="skeleton-store-logo skeleton-loader"></div>
                  </div>
                  <div className="store-info-custom">
                    <div className="skeleton-store-name skeleton-loader"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Sezione Tutti i Negozi - Grid */}
      <div className="seller-grid-section">
        <div className="seller-grid-section-header">
          <div className="skeleton-seller-section-title skeleton-loader"></div>
        </div>
        <div className="seller-grid-grid">
          {[...Array(12)].map((_, index) => (
            <div key={index} className="store-card-custom">
              <div className="store-card-inner-custom">
                <div className="store-logo-container-custom">
                  <div className="skeleton-store-logo skeleton-loader"></div>
                </div>
                <div className="store-info-custom">
                  <div className="skeleton-store-name skeleton-loader"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SellerGridSkeleton; 